module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Left 3-1de5ec846f1ed983ccccb45d83dc5fef.svg";